export default __webpack_public_path__ + "static/media/feather _ chart.14b4a0c6.svg";